<template>
  <tr
    :class="[
      'ms-tr',
      dataRow.IsBold ? 'ms-format-bold' : '',
      dataRow.IsItalic ? 'ms-format-italic' : '',
      allowEdit && dataRow.is_allow_edit ? 'ms-format-noedit' : '',
      allowEdit && dataRow.is_allow_delete ? 'ms-format-delete' : '',
      allowEdit && dataRow.has_edit ? 'has-edit' : '',
      allowEdit && dataRow.has_padding ? 'has-padding' : '',
    ]"
    @mouseover="mouseover"
    @mouseleave="mouseleave"
  >
    <!-- , { 'row-selected': isSelected } -->
    <td v-if="multiple" class="ms-td multiple-cell sticky">
      <ms-checkbox
        @input="checkMultiple"
        class="justify-center"
        ref="multiple"
        checkOnly
        :disabled="disabledCheckedMultipleTbody || disabled"
        :key="0"
        v-model="dataRow.checked"
      />
    </td>
    <td v-if="serial" class="ms-td serial text-center" :class="{sticky: hasLockColumn}">
      {{isCumtomSortOrderGroup ? (dataRow?.indexRowCustom || 0) + 1 : rowIndex + 1 }}
    </td>
    <td v-if="dragRow" @mousedown="cell_click($event, null, null, null)">
      <div class="flex-row flex-center">
        <div
          class="row-editor-action drag drag-data icon20 drag-row ms-td"
          v-tooltip="'Kéo và thả để thay đổi vị trí'"
        ></div>
      </div>
    </td>

    <td
      v-for="(col, i) in columnx"
      :key="col.dataField"
      class="ms-td ms-col-td"
      @dblclick="cell_dblclick($event, col, col.colIndex)"
      :style="[styleWidth(col), {'z-index': columnx.length - i}]"
      :class="[
        col.cssCellClass,
        col.dataField,
        {sticky: col.lock},
        {'ms-col-td-last': col.last},
        dataRow.classes ? dataRow.classes[col.dataField] : '',
        dataRow.is_allow_edit == false && isConfigReport && !propsData[col.dataField]?.isAlwayEdit
          ? 'prevent-action'
          : '',
        dbOptionHeight,
        {disabled: this.checkIsFirefox() && !col.editable && col.columnType != $ms.constant.ColumnType.Action},
      ]"
      :colspan="col.colspan"
      :rowspan="col.rowspan"
      v-show="!col.hidden"
    >
      <!-- propsData[col.dataField]?.isAlwayEdit Dòng dữ liệu có is_allow_edit: false nhưng vẫn muốn sửa thì cột đó cần config isAlwayEdit: true  -->
      <component
        :is="getEditorType(col)"
        :class="[
          {
            disabled: !col.editable && col.columnType != $ms.constant.ColumnType.Action,
            'ms-td-normal-span-unlimited-line': textarea && lineBreak == 0,
            'ms-td-normal-span': textarea && lineBreak == 1,
            'ms-td-normal-span-two-line': textarea && lineBreak == 2,
          },
          {
            'unset-height-firefox':
              this.checkIsFirefox() && !col.editable && col.columnType != $ms.constant.ColumnType.Action,
          },
        ]"
        :col="col"
        :dataRow="dataRow"
        :rowIndex="rowIndex"
        :colIndex="col.colIndex"
        :editable="editable"
        :propsData="propsData[col.dataField] || {}"
        v-model="dataRow[col.dataField]"
        :readOnly="customReadOnly ? customReadOnly(col, dataRow, isSelected) : col.readOnly"
        :customValidateRules="customValidateRules"
        :disabledValidate="customDisabledValidate(col, dataRow)"
        @editorClick="cell_click($event, col, col.colIndex, dataRow)"
        v-on="listeners"
        :ref="`cellEditor_${col.dataField}`"
        :disabled="disabled"
        @eventShortkeyAction="eventShortkey"
        :customControlType="customControlType"
        :customTitle="dataRow.customTitle"
        :lineBreak="lineBreak"
        @copyActionClick="copyActionClick"
        :isCopyDataColumn="isCopyDataColumn"
        :optionMenuLeft="i == lastColumnIndex ? '-21px' : 'unset'"
        :optionMenuRight="i == lastColumnIndex ? 'unset' : '-21px'"
        :isAtLastColumn="i == lastColumnIndex"
        :textAlign="col.textAlign"
        :configVoucherQuickEdit="configVoucherQuickEdit"
        :isQuickEditVoucher="isQuickEditVoucher"
        :textarea="textarea"
      >
      </component>
    </td>
    <td v-if="widgetOptions" class="ms-td widget-item" :style="styleWidth(widgetOptions)" :class="widgetOptions.class">
      <component
        :is="widgetOptions.components"
        :formUsed="widgetOptions.formUsed"
        :dataRow="dataRow"
        @widgetEvent="widgetEvent"
      ></component>
    </td>
    <td :key="100" v-if="$slots.widget" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
  </tr>
</template>
<script>
import msCellInput from './cellEditor/MsCellInput.vue';
import msCellCombobox from './cellEditor/MsCellCombobox.vue';
import msCellComboboxEnum from './cellEditor/MsCellComboboxEnum.vue';
import msCellNumber from './cellEditor/MsCellNumber.vue';
import msCellCheckbox from './cellEditor/MsCellCheckbox.vue';
import msCellDatepicker from './cellEditor/MsCellDatepicker.vue';
import msCellDropdown from './cellEditor/MsCellDropdown.vue';
import msCellAction from './cellEditor/MsCellAction.vue';
import msCellLink from './cellEditor/MsCellLink.vue';
import {useCopyFromExcel} from './cellEditor/CopyFromExcel.js';
import msCellTextarea from './cellEditor/MsCellTextarea.vue';

const msCellState = defineAsyncComponent(() => import('./cellEditor/MsCellState.vue'));

const msCellComboboxMultiple = defineAsyncComponent(() => import('./cellEditor/MsCellComboboxMultiple.vue'));
import {ref, defineAsyncComponent, getCurrentInstance, inject, computed} from 'vue';
export default {
  name: 'msTrEditor',
  components: {
    msCellInput,
    msCellCombobox,
    msCellNumber,
    msCellCheckbox,
    msCellDatepicker,
    msCellDropdown,
    msCellComboboxEnum,
    msCellAction,
    msCellState,
    msCellComboboxMultiple,
    msCellLink,
    msCellTextarea
  },
  props: {
    //Lưu thông tin của các cột
    columns: {},
    //Lưu dữ liệu của dòng
    dataRow: {},
    //Lưu cấu hình của cột chức năng
    widgetOptions: {},
    //Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    rowIndex: {
      default: 0,
      type: Number,
    },
    /**
     * Biến kiểm tra xem có đánh lại STT của các bản ghi không
     * NHANH3 06.06.2024
     */
    isCumtomSortOrderGroup: {
      default: false,
      type: Boolean,
    },
    //Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    //Thuộc tính cấu hình hiện thị cột STT
    serial: {
      default: false,
      type: Boolean,
    },
    //Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    // function Custom ReadOnly
    customReadOnly: {
      type: Function,
      default: null,
    },
    /**
     * NNLAM 22/03/2021
     * hàm custom validate trên cell grid
     */
    customValidateRules: {
      type: [Function, Boolean],
      default: null,
    },
    /**
     * Cho phép sắp xếp lại dữ liệu
     */
    dataDragable: {
      default: false,
      type: Boolean,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    /**
     * Nếu dòng dữ liệu có formular thì ko được phép sửa
     * NXCHIEN 21.09.2022
     */
    isConfigReport: {
      default: true,
      type: Boolean,
    },
    /**
     * Cấu hình cho phép sửa - báo cáo quyết toán
     * TPNAM 28/09/2022
     */
    allowEdit: {
      default: false,
      type: Boolean,
    },

    /**
     * Biến này ko đưuọc phép dùng
     * NXCHIEN 04.01.2022
     */
    customControlType: {
      default: false,
      type: Boolean,
    },

    /**
     * biến này custom lại định dạng của cell
     * tvhien 18.01.2023
     */
    customCellEditor: {
      type: Function,
      default: null,
    },
    // Hiện thị số dòng cho phép.
    lineBreak: {
      default: 1,
      type: Number,
    },
    /**
     * Cấu hình sao chép dữ liệu 1 cột xuống các cột khác (mục đích để dev phải check lại các màn hình đã làm để tránh lỗi dữ liệu)
     * dtnga3 (26.05.2023)
     */
    isCopyDataColumn: {
      default: false,
      type: Boolean,
    },
    dragRow: {
      default: false,
      type: Boolean,
    },
    //Sửa nhanh chứng từ
    isQuickEditVoucher: {
      type: Boolean,
      default: false,
    },
    // config dùng cho sửa nhanh chứng từ
    configVoucherQuickEdit: {
      default: [],
      type: Array,
    },
    // Text ở dạng textarea thay vì input
    textarea: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      /**
       * Hiển thị row action không
       */
      showRowAction: false,
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
      rowActionsCustom: [],

      customShowAction: false,
    };
  },
  setup(props, {emit}) {
    const refCell = ref([]);
    const {proxy} = getCurrentInstance();
    // const customCellEditor = inject('customCellEditor');
    //Lấy lại control editor
    //Created by LTDAT (17.06.2020)
    const getEditorType = col => {
      const me = proxy;
      if (props.customCellEditor && typeof props.customCellEditor === 'function') {
        const cellName = props.customCellEditor(col, props.dataRow);
        if (cellName) return cellName;
      }
      switch (col.columnType) {
        case me.$ms.constant.ColumnType.Enum:
          return 'msCellComboboxEnum';
        case me.$ms.constant.ColumnType.Combobox:
          return 'msCellCombobox';
        case me.$ms.constant.ColumnType.Number:
          return 'msCellNumber';
        case me.$ms.constant.ColumnType.Checkbox:
          return 'msCellCheckbox';
        case me.$ms.constant.ColumnType.Datepicker:
        case me.$ms.constant.ColumnType.Time:
          return 'msCellDatepicker';
        case me.$ms.constant.ColumnType.Dropdown:
          return 'msCellDropdown';
        case me.$ms.constant.ColumnType.Template:
          return col.template;
        case me.$ms.constant.ColumnType.Action:
          return 'msCellAction';
        case me.$ms.constant.ColumnType.State:
          return 'msCellState';
        case me.$ms.constant.ColumnType.ComboboxMultiple:
          return 'msCellComboboxMultiple';
        case me.$ms.constant.ColumnType.Link:
          return 'msCellLink';
          case me.$ms.constant.ColumnType.TextArea:
          return 'msCellTextarea';
        default:
          return 'msCellInput';
      }
    };

    const {convertCopyData, formatCopyFromExcel} = useCopyFromExcel();

    /**
     * Bổ sung custom span
     */
    const spanMethod = inject('spanMethod');

    /**
     * Loại bỏ các column ko có span
     */
    const columnx = computed(() => {
      if (!props.columns) return [];
      const cols = [];
      props.columns.forEach((col, i) => {
        const {colspan, rowspan} = getSpan(col, props.dataRow, i);
        if (colspan) {
          cols.push({...col, ...{colspan: colspan, rowspan: rowspan}, colIndex: i});
        }
      });
      return cols;
    });

    /** Số thứ tự cột cuối cùng không tính cột actionRow
     * dtnga3 (31.05.2023)
     */
    const lastColumnIndex = computed(() => {
      return columnx.value.filter(x => x.columnType != proxy.$ms.constant.ColumnType.Action).length - 1;
    });

    /**
     * Get span của ô
     */
    const getSpan = (col, dataRow, colIndex) => {
      const defaultSpanObj = {colspan: 1, rowspan: 1};
      if (typeof spanMethod === 'function') {
        const spanObj = spanMethod(col, dataRow, colIndex);
        if (!spanObj) return defaultSpanObj;
        return spanObj;
      }
      return defaultSpanObj;
    };
    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    return {
      refCell,
      getEditorType,
      getSpan,
      columnx,
      dbOptionHeight,
      lastColumnIndex,
      convertCopyData,
      formatCopyFromExcel,
    };
  },
  computed: {
    /**
     * Nếu có check all sẽ thực hiện check all
     */
    isChecked() {
      const {disabledCheckedMultipleTbody, isCheckedAll, isSelected} = this;
      return disabledCheckedMultipleTbody ? false : isCheckedAll || isSelected;
    },
    listeners() {
      const me = this;
      return {
        // selected: (metaData) => {
        //   me.$emit('selected', metaData);
        // },
        // change: (metaData) => {
        //   me.$emit('change', metaData);
        // },
        // rowSelected: (data) => {
        //   me.$emit('rowSelected', data);
        // },
        // next: () => {
        //   me.$emit('next');
        // },
        /**
         * Emit sau khi select combobox
         * PQDat 30.03.2023
         */
        comboBoxSelectItem: metaData => {
          me.$emit('comboBoxSelectItem', metaData, me.dataRow);
        },
        comboboxLoadData: (payload, col) => {
          me.$emit('comboboxLoadData', payload, me.dataRow, col);
        },
        submitQuickAdd: () => {
          me.$emit('submitQuickAdd', ...arguments);
        },
        [me.$ms.constant.CustomEvent.MsKeydown]: e => {
          me.editorKeydown(e);
        },
        gridRowActionClick: (command, rowIndex) => {
          if (!this.disabled) {
            me.$emit('gridRowActionClick', command, rowIndex);
          }
        },
        gridRowStateClick: (metaData, rowIndex) => {
          if (!this.disabled) {
            me.$emit('gridRowStateClick', metaData, rowIndex);
          }
        },
        viewLinkedForm(col, dataRow, e) {
          if (col && col.linkedForm && col.linkedForm != '') {
            me.$emit('viewLinkedForm', col, dataRow, e);
          }
        },
        pasteInput(e, pasteColumn) {
          // Danh sách cột cần paste
          let colToPaste = [];
          let {clipboardData, formatOptions} = me.convertCopyData(e);

          clipboardData = clipboardData.filter(x => x.length);

          // Đánh dấu trong vùng copy
          let inPaste = false;
          // Lấy độ rộng vùng copy từ excel
          let rowLength = clipboardData[0].length;
          // For theo cột của bảng
          for (const col of me.columnx) {
            // Đánh dấu bắt đầu vào vùng copy
            if (inPaste == false && col.dataField == pasteColumn.dataField) {
              inPaste = true;
            }
            // Khi vào vùng copy thì đẩy danh sách các cột cần copy
            if (inPaste) {
              if (colToPaste.length < rowLength) {
                colToPaste.push(col);
              } else {
                break;
              }
            }
          }

          let pasteData = [];
          for (let rIndex = 0; rIndex < clipboardData.length; rIndex++) {
            const rowPasteData = clipboardData[rIndex];
            let rowData = {};
            for (let index = 0; index < colToPaste.length; index++) {
              let col = colToPaste[index];
              rowData[col.dataField] = me.formatCopyFromExcel(rowPasteData[index], col, formatOptions);
            }
            pasteData.push(rowData);
          }
          me.$emit('pasteInput', pasteData, me.rowIndex);
        },
        callbackAddData(dataRow) {
          me.$emit('callbackAddData', dataRow, me.rowIndex);
        },
      };
    },
  },
  methods: {
    styleWidth(col) {
      let rs = {};

      if (col.minWidth) {
        rs.minWidth = col.minWidth + 'px';
        rs['max-width'] = `${col.minWidth}px`;
      }

      if (col.width) {
        rs.width = col.width + 'px';
        rs['max-width'] = `${col.width}px`;
      }

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      return rs;
    },

    //Emit sự kiện từ widget ra ngoài
    // Created by LTDAT (16.06.2020)
    widgetEvent(data, event) {
      const me = this;
      me.$emit('widgetEvent', data, event);
    },
    //Emit sự kiện click row ra ngoài grid
    //Created by LTDAT(13/06/2020)
    cell_click(e, col, colIndex, dataRow) {
      const me = this;
      const info = {colIndex: colIndex, rowIndex: this.rowIndex, col: col};
      if (
        !this.disabled ||
        (this.isQuickEditVoucher && this.configVoucherQuickEdit.includes(col.dataField)) ||
        this.dragRow
      ) {
        me.$emit('cellClick', info);
      }
    },
    // Xử lý disable ô custom theo propsData
    customDisabledValidate(col, dataRow) {
      return typeof this.propsData[col.dataField]?.customDisabledValidate == 'function'
        ? this.propsData[col.dataField]?.customDisabledValidate(dataRow)
        : false;
    },
    //Emit sự kiện dblclickRow ra ngoài grid
    //Created by LTDAT(13/06/2020)
    cell_dblclick(e, col, colIndex) {
      const me = this;
      me.$emit('dblclick_cell', me.dataRow, e);
    },
    //Sự kiện click vào nút chọn ở cột multiple
    //Created by LTDAT (28.05.2020)
    checkMultiple(event) {
      const me = this;
      // me.dataRow.IsSelected = !me.isSelected;
      const checked = event.target.tagName.toLowerCase() === 'input' ? event.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, me.rowIndex, checked, event);
    },
    mouseover(event) {
      const me = this;
      me.$emit('mouseover', me.dataRow, event);

      me.$nextTick(() => {
        //nếu có action -> hiển thị
        if (me.rowActions != null && me.rowActions.length > 0) {
          //giữ lại record dc click cuối cùng
          me.actionRecord = me.dataRow;
          me.showRowAction = true;

          //đợi action render xong
          me.$nextTick(() => {
            let actionEl = me.$refs.rowAction;
            let actionWidth = 0;
            if (actionEl) {
              let actionElOffset = actionEl.getBoundingClientRect();
              actionWidth = actionElOffset.width;
            }

            let trEl = event.target.closest('tr');
            if (trEl) {
              let trOffset = trEl.getBoundingClientRect();
              let containerOffset = trEl.closest('.ms-content--table').getBoundingClientRect();

              let scrollContainer = trEl.closest('.scroller'),
                scrollLeft = scrollContainer.scrollLeft;

              //set position display
              me.rowActionStyle = {
                // top: trOffset.top + 'px',
                left: containerOffset.width - actionWidth + scrollLeft + 'px',
              };
            }
          });
        }
      });
    },
    eventScrollGrid(trEl) {
      const me = this;
      if (me.rowActions != null && me.rowActions.length > 0) {
        let actionEl = me.$refs.rowAction;
        //me.showRowAction = true;
        let actionWidth = 0;
        if (actionEl) {
          let actionElOffset = actionEl.getBoundingClientRect();
          actionWidth = actionElOffset.width;
        }
        if (trEl) {
          let trOffset = trEl.getBoundingClientRect();
          let containerOffset = trEl.closest('.ms-content--table').getBoundingClientRect();

          let scrollContainer = trEl.closest('.scroller'),
            scrollLeft = scrollContainer.scrollLeft;
          let left = containerOffset.width - actionWidth + scrollLeft;
          if (scrollContainer.scrollWidth - actionWidth < containerOffset.width - actionWidth + scrollLeft) {
            left = scrollContainer.scrollWidth - actionWidth;
          }

          //set position display
          me.rowActionStyle = {
            // top: trOffset.top + 'px',
            left: left + 'px',
          };
        }
      }
    },
    rowActionClick(action, event) {
      const me = this;
      if (action.command === 'MORE') {
        let menu = me.$refs.actionMenu;
        if (!menu.show) {
          setTimeout(() => {
            menu.open(event);
          }, 10);
        }
      } else {
        // me.$parent.$emit("rowactionclick", action.command, me.dataRow, event);
        me.$emit('rowactionclick', action.command, me.dataRow, event);
      }
    },
    /**
     * Xử lý sự kiện keydown cho editor
     * Các phím đặc biệt như tab, enter -> di chuyển editor
     */
    editorKeydown(e) {
      this.$emit(this.$ms.constant.CustomEvent.MsKeydown, e, this.rowIndex);
    },

    /**
     * Xử lý shortkey action
     * HQMINH 22.08.2022
     */
    eventShortkey(e, col, colIndex) {
      if (this.getEditorType(col) == 'msCellCombobox') {
        this.$emit('eventShortkeyAction', e, col, colIndex);
      }
    },

    /**
     * Thực hiện sao chép số liệu dòng hạch toán
     * dtnga3 (19.05.2023)
     */
    copyActionClick(actionId, rowIndex, colIndex) {
      this.$emit('copyActionClick', actionId, rowIndex, colIndex);
    },

    /**
     * kiểm tra xem người dùng có đang dùng firefox không
     * ldduy (18.7.2023)
     */
    checkIsFirefox() {
      const isFirefox = /firefox/i.test(navigator.userAgent);
      return isFirefox;
    },

    setRowValue(rowData) {
      const me = this;
      if (me.dataRow.state == me.$ms.constant.ModelState.Empty) {
        me.dataRow.state = me.$ms.constant.ModelState.Insert;
      }
      if (me.dataRow.state == me.$ms.constant.ModelState.None) {
        me.dataRow.state = me.$ms.constant.ModelState.Update;
      }
      // Kết quả paste để xử lý nghiệp vụ (Xử lý cho combobox)
      let pasteResult = {};
      // For từng cột để gọi gàm setValue trong MsCell xử lý gán dữ liệu
      for (const col in rowData) {
        let cellComponent = me.$refs[`cellEditor_${col}`];
        if (cellComponent && typeof cellComponent[0]?.setValue == 'function') {
          let result = cellComponent[0].setValue(rowData[col]);
          // Gán lại kết quả paste dữ liệu
          if (result) {
            pasteResult[col] = result;
          }
        }
      }

      return pasteResult;
    },
  },
};
</script>
<style lang="scss" scoped>
// @media screen and (max-width: 1366px) {
// 	@import '@/assets/scss/_sm-variables.scss';
// 	@import '@/assets/scss/components/MsTrViewer.scss';
// }
// @media screen and (min-width: 1367px) {
//
// 	@import '@/assets/scss/components/MsTrViewer.scss';
// }

@import '@/assets/scss/components/MsTrViewer.scss';

:deep(.ms-td) {
  padding: unset;
  &.drag-row {
    width: 30px;
    height: 30px;
    border-right: 1px dotted #c1c4cc;
    &::before {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    border-bottom: unset;
  }
  &.tax_rate {
    .editor-display {
      text-align: right;
    }
    .editor-display-2 {
      text-align: right;
    }
    .input {
      text-align: right;
    }
  }
  .editor-display {
    padding: $ms-grid-cellpadding;
    flex: 1;
  }
  .editor-display-2 {
    padding: $ms-grid-cellpadding;
    flex: 1;
  }
  .padding-left-right {
    padding: $ms-grid-cellpadding;
    flex: 1;
  }
  &.rowAction {
    right: 0;
    position: sticky;
    border-left: 1px dotted $ms-grid-border-color;
    border-right: none;
    z-index: 1 !important;
  }
  .ms-cell-editor {
    position: relative;
    .error {
      position: absolute;
      left: 4px;
    }
    .error-cell {
      position: relative;
      left: 0;
    }
  }
  a.editor-click {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    &:focus {
      border: 1px solid #e0e0e0;
      outline-offset: 1px #e0e0e0;
    }
  }
  .ms-cell-editor {
    width: 100%;
    height: 100%;
  }
  .cell-error {
    a.editor-click {
      padding-left: 24px;
    }
  }
  &.heightoptionvalue1 {
    height: $input-height-custom-small-with-border !important;
    min-height: $input-height-custom-small-with-border !important;
  }
  &.heightoptionvalue2 {
    height: 28px !important;
    min-height: 27px;
    &.ms-col-td {
      min-height: 28px !important;
      height: 28px !important;
    }
  }
}

.ms-cell-editor {
  &:focus {
    border: 1px solid $primary;
  }
}

:deep(.editor-display) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.editor-display-2) {
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
:deep(.ms-editor) {
  .ms-number-item,
  .ms-input-item,
  .ms-input--datepicker,
  .input {
    padding: $ms-grid-cellpadding-editor;
  }
}

.ms-td.drag-data {
  padding: $ms-grid-cellpadding;
  .move {
    margin: 0 auto;
    &:hover {
      cursor: pointer;
    }
  }
}
.disabled {
  background-color: $ms-grey !important;
}

.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}

.prevent-action {
  background-color: $ms-grey;
  &:active {
    pointer-events: none;
  }
}

.unset-height-firefox {
  height: auto !important;
}
</style>
